import Login from '../components/Login';
// import BasicForm from "../components/Forms/LoginForm";
import '../App.css';
// import Background from "../components/Background";

function LoginPage() {
    return <Login />;
}
export default LoginPage;
